import { render, staticRenderFns } from "./simulation.vue?vue&type=template&id=efc7dafc&scoped=true"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"
import style0 from "./simulation.vue?vue&type=style&index=0&id=efc7dafc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc7dafc",
  null
  
)

export default component.exports